import React, { useEffect, useRef, useState } from "react";
import Texas from "../Images/Texas.png";
import bosch from "../Images/bosch.png";
import ABB from "../Images/ABB.png";
import IFB from "../Images/IFB.png";
import adl from "../Images/adl.png";
import PES from "../Images/PES.jpg";
import FYN from "../Images/FYN.png";
import river from "../Images/river.webp";
import DRDO from "../Images/DRDO.png";
import { Typography } from "@mui/material";

const bgStyle = {
  width: "100vw",
  background: "#111",
  padding: "80px 64px",
  margin: "0",
  overflow: "hidden",
  position: "relative",
};

const companies = [
  { name: "Texas Instruments", logo: Texas },
  { name: "Bosch", logo: bosch },
  { name: "ABB", logo: ABB },
  { name: "IFB", logo: IFB },
  { name: "Adithya Lamps", logo: adl },
  { name: "PES University", logo: PES },
  {
    name: "RV College",
    logo: "https://rvce.edu.in/sites/default/files/logo_0_0.png",
  },
  { name: "Fyn Mobility", logo: FYN },
  { name: "River Mobility", logo: river },
  { name: "DRDO", logo: DRDO },
];

const containerStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
  gap: "2.5rem",
  zIndex: 2,
  position: "relative",
};

const cardStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  background: "rgba(34, 34, 34, 0.95)",
  borderRadius: "18px",
  boxShadow: "0 6px 26px 0 rgba(40,40,40,0.21)",
  padding: "1.3rem 0.8rem 1rem",
  transition: "transform 0.35s cubic-bezier(.25,1.5,.50,1), box-shadow 0.3s",
  opacity: 0,
  transform: "translateY(30px) scale(0.98)",
  height: "180px",
  justifyContent: "center",
};

const nameStyle = {
  fontWeight: 600,
  fontSize: "1rem",
  color: "#f2f2f2",
  textAlign: "center",
  letterSpacing: "0.03em",
  textShadow: "0 1px 4px #000A",
};

// Logo wrapper remains same
const logoWrapperStyle = {
  width: "100%",
  height: "95px", // slightly taller to fit larger logos
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: "0.75rem",
};

const logoStyle = {
  maxWidth: "130px", // was 100px
  maxHeight: "75px", // was 60px
  objectFit: "contain",
  filter: "drop-shadow(0 2px 8px #222) brightness(0.97)",
  background: "#fff",
  borderRadius: "12px",
  padding: "8px 10px", // a little extra padding for visual balance
};

const squareLogoStyle = {
  ...logoStyle,
  maxWidth: "85px", // was 70px
  maxHeight: "85px", // was 70px
  borderRadius: "14px",
};

function getAnimationDelay(i) {
  return { animationDelay: `${0.13 * i + 0.3}s` };
}

function Companies() {
  const [animate, setAnimate] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (entry.isIntersecting) {
          setAnimate(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section style={bgStyle} id="companies-section" ref={sectionRef}>
      <style>
        {`
        @keyframes cardReveal {
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }
        #companies-section h2 {
          color: #fbfbfb;
          text-align: center;
          font-size: 2.2rem;
          margin-bottom: 2.6rem;
          margin-top: 0;
          font-weight: 700;
          letter-spacing: 3px;
          text-shadow: 0 3px 7px #1117;
        }
        .company-card.animate {
          animation: cardReveal 1s forwards;
        }
        .company-card:hover {
          transform: scale(1.06) translateY(-4px);
          box-shadow: 0 12px 40px #4449, 0 2px 12px #1116;
          background: rgba(46,46,46,0.98);
        }
        `}
      </style>

      <Typography
        variant="h4"
        fontWeight="bold"
        sx={{
          textAlign: "center",
          mb: 6,
          color: "white",
          fontSize: { xs: "2rem", sm: "2.5rem" },
        }}
      >
        Driven by Partnerships
      </Typography>

      <div style={containerStyle}>
        {companies.map((company, i) => {
          const isSquare =
            company.name === "RV College" || company.name === "DRDO";
          return (
            <div
              key={company.name}
              style={{ ...cardStyle, ...(animate ? getAnimationDelay(i) : {}) }}
              className={`company-card ${animate ? "animate" : ""}`}
            >
              <div style={logoWrapperStyle}>
                <img
                  src={company.logo}
                  alt={`${company.name} Logo`}
                  style={isSquare ? squareLogoStyle : logoStyle}
                  onError={(e) => {
                    e.target.src =
                      "https://via.placeholder.com/70x70?text=No+Logo";
                  }}
                  draggable={false}
                />
              </div>
              <span style={nameStyle}>{company.name}</span>
            </div>
          );
        })}
      </div>
    </section>
  );
}

export default Companies;
